import 'angular';

import { PartsAuthorityInvoiceService } from './parts-authority.invoice.service';
import { PartsAuthorityOrderService }   from './parts-authority.order.service';
import { PartsAuthorityStates }         from './parts-authority.states.ajs';
import { PartsAuthoritySettingsCtrl }   from './parts-authority.settings';

angular.module('workshop.parts-authority', [])
  .config(PartsAuthorityStates)
  .controller('PartsAuthoritySettingsCtrl', PartsAuthoritySettingsCtrl)
  .factory('PartsAuthorityInvoice', PartsAuthorityInvoiceService)
  .factory('PartsAuthorityOrder', PartsAuthorityOrderService);
